import React, { useState } from 'react';
import { Project } from '../data/portfolio-data';
import ProjectCard from './ProjectCard';
import { portfolioData as projects } from '../data/portfolio-data';
import ProjectDetailsModal from './ProjectDetailsModal';

export const Portfolio = () => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [selectedFilter, setSelectedFilter] = useState('all');

  const filters = ['all', 'web', 'mobile', 'desktop', 'cloud'];

  const filteredProjects = selectedFilter === 'all'
    ? projects
    : projects.filter(project => project.categories.includes(selectedFilter));

  return (
    <section id="our-work" className="py-16 lg:py-24 bg-gradient-to-b from-blue-950 to-blue-900">
      <div className="container mx-auto max-w-[1400px] px-6">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            My Work
          </h2>
          <p className="text-blue-200 text-lg max-w-2xl mx-auto">
            Explore my portfolio of successful projects where I've helped businesses transform their digital presence and operations.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {filters.map(filter => (
            <button
              key={filter}
              onClick={() => setSelectedFilter(filter)}
              className={`
                px-5 py-2 rounded-full text-sm font-medium transition-all duration-200
                ${selectedFilter === filter
                  ? 'bg-blue-500 text-white'
                  : 'bg-blue-900/30 text-blue-200 hover:bg-blue-900/50'
                }
              `}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 gap-8 lg:gap-12">
          {filteredProjects.map(project => (
            <ProjectCard
              key={project.title}
              project={project}
              onOpenDetails={(p) => setSelectedProject(p)}
            />
          ))}
        </div>
      </div>

      {/* Project Details Modal */}
      {selectedProject && (
        <ProjectDetailsModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </section>
  );
};

export default Portfolio;